export const contactTypeTypes = {
  ON_SELECT_CONTACT_AREA: "ON_SELECT_CONTACT_AREA",
  ON_CHANGE: "ON_CHANGE",
};
